<template>
  <Widget :headline="$t('cs.widget.headline')">
    <InViewAnimation>
      <CareServiceBudgetPackageWidget slot="1" :variant="variant" />
    </InViewAnimation>

    <template slot="bottom">
      <template v-for="(item, i) in bottomLink[variant]">
        <Button
          :key="i"
          v-if="item.isButton"
          v-bind="item"
          additionalIconName="arrow-right-line"
          additionalIconPos="right"
          small
        />
        <Link
          v-else
          :key="i"
          :to="item.href"
          :onClick="item.onClick"
          icon="arrow-right-line"
          iconPos="right"
        >
          {{ item.label }}
        </Link>
      </template>
    </template>
  </Widget>
</template>

<script>
import Widget from '@/objects/Widget';
import InViewAnimation from '@/components/InViewAnimation';
import { CareServiceBudgetPackageWidget } from '@/components/CareServiceBudgetPackage';
import Button from '@/objects/Button';
import Link from '@/objects/Link';

import {
  ROUTE_ANALYSE_CARE_SERVICE,
  ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR,
} from '@/constants/routes';

import mixin from '@/mixins/careService';

import { HEALTH_TOGGLE_CARE_LEVEL_MODAL } from '@/store/actions/health';

export default {
  name: 'PflegeleistungsfinderWidget',
  props: {},
  mixins: [mixin],
  components: {
    Widget,
    InViewAnimation,
    CareServiceBudgetPackageWidget,
    Button,
    Link,
  },
  computed: {
    variant() {
      /**
       * 0: Es gibt noch keinen Pflegegrad
       * 1: Es wurden bisher keine Pflegeleistungen zusammengestellt
       * 2: Alle Werte vorhanden
       */

      let variant = 2;

      if (!this.careLevel) {
        variant = 0;
      }

      if (this.careLevel && !this.careServiceWizardIsFinished) {
        variant = 1;
      }

      return variant;
    },
  },
  data() {
    return {
      ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
      ROUTE_ANALYSE_CARE_SERVICE,
      el: 'v-plfWidget',
      bottomLink: [
        [
          {
            isButton: true,
            label: this.$t('cs.widget.link4'),
            href: ROUTE_SERVICE_CARELEVEL_CALCULATOR,
            type: 'outlined',
            onClick: () =>
              this.$emit('onTrackingClick', '_btn-' + this.$t('cs.widget.link4'), 'button'),
          },
          { label: this.$t('cs.widget.link3'), onClick: () => this.openModal() },
        ],
        [
          {
            isButton: true,
            label: this.$t('cs.widget.link2'),
            href: ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
            type: 'outlined',
            onClick: () =>
              this.$emit('onTrackingClick', '_btn-' + this.$t('cs.widget.link2'), 'button'),
          },
        ],
        [
          {
            label: this.$t('cs.widget.link1'),
            href: ROUTE_ANALYSE_CARE_SERVICE,
            onClick: () =>
              this.$emit('onTrackingClick', '_link-' + this.$t('cs.widget.link1'), 'link'),
          },
        ],
      ],
    };
  },
  methods: {
    openModal() {
      this.$store.dispatch(HEALTH_TOGGLE_CARE_LEVEL_MODAL);
    },
  },
  created() {},
  mounted() {},
};
</script>
